import BreadcrumbsService from '@/services/breadcrumbs'

export default {
  created() {
    BreadcrumbsService.set(this.breadcrumbs)
  },
  watch: {
    breadcrumbs(breadcrumbs) {
      BreadcrumbsService.set(breadcrumbs)
    }
  }
}
